<template>
	<SpinningWheelSVG
		class="wheel"
		v-bind="$attrs"
		:slices="sectionArray"
		:degreesOfRotation="spinAmount"
		:spinning="spinning"
	/>
</template>

<script>
import { randomIndex, randomBetween } from '@/lib/random';
import { arrayObjectsHaveAllKeys } from '@/lib/validators';
import SpinningWheelSVG from '@/components/game/spin/wheel/SpinningWheelSVG';

export default {
	name: 'Wheel',
	components: {
		SpinningWheelSVG,
	},
	props: {
		sections: {
			type: [Object, Array],
			required: false,
			validator: arrayObjectsHaveAllKeys(["id", "model", "symbol"]),
		},
		spinCount: {
			type: Number,
			required: false,
			default: 10,
		},
		pointerPosition: {
			type: Number,
			required: false,
			default: 0,
			validate: (position) => (position >= 0 && position <= 360),
		},
	},
	data() {
		return {
			availableSections: [],
			didSpin: false,
			spinAmount: 0,
			spinning: false,
			spinOutcome: '',
		};
	},
	computed: {
		sectionArray() {
			return Object.values(this.sections).map((section, index) => {
				const start = index * this.sliceArcLength;
				const end = (index + 1) * this.sliceArcLength;
				return {
					...section,
					arc: { start, end },
					css: { start: 360 - start, end: 360 - end },
				};
			});
		},
		sliceArcLength() {
			return 360 / Object.values(this.sections).length;
		},
	},
	methods: {
		spin(id = false) {
			if (this.spinning) {
				return;
			}
			this.$emit("spin");

			let index = randomIndex(this.availableSections);

			if (id) {
				const selected = this.availableSections.findIndex((section) => section.id === id);
				index = selected > -1 ? selected : index;
			}

			const section = this.availableSections.splice(index, 1);
			this.spinTo(section[0]);
			this.maybeRefillAvailableSections();
		},
		spinTo(section) {
			this.spinning = true;
			this.spinAmount = randomBetween(section.css.start, section.css.end)
				+ (this.spinCount * 360) + this.pointerPosition;

			setTimeout(() => {
				this.spinOutcome = section;
				this.spinAmount -= (this.spinCount * 360);
				this.spinning = false;
				this.didSpin = true;
				this.$emit('spin-complete', this.spinOutcome);
			}, 7500);
		},
		maybeRefillAvailableSections() {
			if (!this.availableSections.length) {
				this.availableSections = [...this.sectionArray];
			}
		},
	},
	mounted() {
		// centers initial element
		this.spinAmount = this.pointerPosition - (this.sliceArcLength / 2);
		this.maybeRefillAvailableSections();
	},
};
</script>

<style lang="scss" scoped>
	.spin-btn {
		position: absolute;
		color: white;
		height: max-content;
		width: max-content;
		top: 4.25vw; // approximated bc of $flipper-offset
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		font-size: $font-size-xl;
		z-index: $z-top;

		@include tablet {
			top: 25px; // approximated bc of $flipper-offset
		}

		@include desktop { display: none; }

		&:after {
			content: '';
			background: black;
			border-radius: 50%;
			height: 100px;
			width: 100px;
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			margin: auto;
			z-index: -1;
		}

		&.btn { border: none; }
	}
</style>
